export const common = {
  // Header
  'header.home': 'Início',
  'header.about': 'Sobre',
  'header.faq': 'Perguntas',
  'header.contact': 'Contato',
  'header.signIn': 'Entrar',
  'header.getStarted': 'Começar',

  // Footer
  'footer.tagline': 'Eleve seu futuro financeiro',
  'footer.description': 'Soluções de pagamento seguras, confiáveis e inovadoras para indivíduos e empresas em todo o mundo.',
  'footer.quickLinks': 'Links rápidos',
  'footer.services': 'Serviços',
  'footer.contact': 'Contate-nos',
  'footer.address': '789 Summit Avenue, San Francisco, CA 94102',
  'footer.email': 'support@pinnaclepayments.com',
  'footer.phone': '+1 (415) 555-1234',
  'footer.copyright': '© 2024 Pinnacle Payments. Todos os direitos reservados.',
  'footer.privacy': 'Política de privacidade',
  'footer.terms': 'Termos de serviço',

  // Home Page
  'home.hero.title': 'Eleve seu futuro financeiro',
  'home.hero.subtitle': 'Experimente serviços bancários perfeitos com tecnologia de ponta. Gerencie sua riqueza, invista com inteligência e alcance seus objetivos financeiros com Pinnacle Payments.',
  'home.hero.cta': 'Comece hoje',
  'home.hero.learn': 'Saiba mais',

  'home.stats.users': 'Usuários ativos',
  'home.stats.countries': 'Países atendidos',
  'home.stats.transactions': 'Transações processadas',
  'home.stats.support': 'Suporte 24/7',

  'home.services.title': 'Nossos serviços premium',
  'home.services.subtitle': 'Soluções financeiras abrangentes adaptadas às suas necessidades',

  'home.services.banking.title': 'Banco digital',
  'home.services.banking.desc': 'Banco moderno na ponta dos dedos com transferências instantâneas, pagamentos de contas e rastreamento de saldo em tempo real.',

  'home.services.investment.title': 'Soluções de investimento',
  'home.services.investment.desc': 'Aumente sua riqueza com nossos portfólios de investimento selecionados e orientação financeira especializada.',

  'home.services.loans.title': 'Empréstimos flexíveis',
  'home.services.loans.desc': 'Empréstimos pessoais e comerciais de aprovação rápida com taxas competitivas e condições de pagamento flexíveis.',

  'home.services.cards.title': 'Cartões virtuais',
  'home.services.cards.desc': 'Cartões de débito e crédito virtuais seguros para compras online e transações internacionais seguras.',

  'home.features.title': 'Por que escolher Pinnacle Payments',
  'home.features.subtitle': 'Experimente a excelência bancária com recursos líderes do setor',

  'home.features.security.title': 'Segurança bancária',
  'home.features.security.desc': 'Seus fundos são protegidos com criptografia de nível militar e autenticação multifator.',

  'home.features.instant.title': 'Transferências instantâneas',
  'home.features.instant.desc': 'Envie e receba dinheiro instantaneamente em mais de 180 países sem atrasos.',

  'home.features.support.title': 'Suporte especializado 24/7',
  'home.features.support.desc': 'Nossa equipe dedicada está sempre disponível para ajudá-lo com quaisquer perguntas ou preocupações.',

  'home.features.rates.title': 'Taxas competitivas',
  'home.features.rates.desc': 'Desfrute das melhores taxas de câmbio e das taxas mais baixas do setor para todas as transações.',

  'home.plans.title': 'Planos de crescimento financeiro',
  'home.plans.subtitle': 'Escolha o plano perfeito para alcançar seus objetivos financeiros',

  'home.plans.dps.title': 'Esquema de pensão de depósito',
  'home.plans.dps.rate': 'Retorno anual',
  'home.plans.dps.term': 'Termos flexíveis',
  'home.plans.dps.feature1': 'Opções de depósito mensal',
  'home.plans.dps.feature2': 'Retornos garantidos',
  'home.plans.dps.feature3': 'Benefícios fiscais',
  'home.plans.dps.feature4': 'Opção de retirada antecipada',
  'home.plans.dps.cta': 'Comece a economizar',

  'home.plans.fdr.title': 'Recibo de depósito fixo',
  'home.plans.fdr.rate': 'Taxa de juros',
  'home.plans.fdr.term': 'Período de bloqueio',
  'home.plans.fdr.feature1': 'Retornos altos garantidos',
  'home.plans.fdr.feature2': 'Opções de prazo flexíveis',
  'home.plans.fdr.feature3': 'Empréstimo contra FDR',
  'home.plans.fdr.feature4': 'Renovação automática disponível',
  'home.plans.fdr.cta': 'Investir agora',

  'home.plans.loan.title': 'Empréstimos pessoais',
  'home.plans.loan.rate': 'A partir de',
  'home.plans.loan.term': 'Período de pagamento',
  'home.plans.loan.feature1': 'Aprovação rápida em 24 horas',
  'home.plans.loan.feature2': 'Sem taxas ocultas',
  'home.plans.loan.feature3': 'Opções EMI flexíveis',
  'home.plans.loan.feature4': 'Documentação mínima',
  'home.plans.loan.cta': 'Aplicar agora',

  'home.testimonials.title': 'O que nossos clientes dizem',
  'home.testimonials.subtitle': 'Junte-se a milhares de clientes satisfeitos em todo o mundo',

  'home.cta.title': 'Pronto para transformar seu futuro financeiro?',
  'home.cta.subtitle': 'Junte-se a milhões de usuários que confiam no Pinnacle Payments para suas necessidades financeiras',
  'home.cta.button': 'Crie sua conta',

  // About Page
  'about.hero.title': 'Sobre Pinnacle Payments',
  'about.hero.subtitle': 'Liderando o futuro das finanças digitais desde 2010',

  'about.story.title': 'Nossa história',
  'about.story.content': 'Fundada em 2010, a Pinnacle Payments surgiu de uma visão de revolucionar a indústria de serviços financeiros. Reconhecemos que o setor bancário tradicional estava falhando em atender às necessidades de um mundo digital em rápida evolução. Nossos fundadores, uma equipe de pioneiros em fintech e veteranos bancários, se propuseram a criar uma plataforma que combina tecnologia de ponta com serviço personalizado. Hoje, atendemos mais de 8 milhões de clientes em 180 países, processando bilhões em transações anualmente, mantendo nosso compromisso com segurança, inovação e satisfação do cliente.',

  'about.mission.title': 'Nossa missão',
  'about.mission.content': 'Capacitar indivíduos e empresas em todo o mundo com soluções financeiras acessíveis, seguras e inovadoras que lhes permitam alcançar seus objetivos e construir prosperidade duradoura.',

  'about.vision.title': 'Nossa visão',
  'about.vision.content': 'Tornar-se a plataforma financeira digital mais confiável do mundo, estabelecendo novos padrões de excelência, segurança e experiência do cliente na indústria fintech.',

  'about.stats.customers': 'Clientes satisfeitos',
  'about.stats.transactions': 'Transações processadas',
  'about.stats.countries': 'Países em todo o mundo',
  'about.stats.rating': 'Avaliação do cliente',

  'about.values.title': 'Nossos valores fundamentais',
  'about.values.security.title': 'Segurança em primeiro lugar',
  'about.values.security.desc': 'Priorizamos a segurança de seus fundos e dados acima de tudo.',
  'about.values.innovation.title': 'Inovação',
  'about.values.innovation.desc': 'Evoluindo continuamente para fornecer soluções financeiras de ponta.',
  'about.values.transparency.title': 'Transparência',
  'about.values.transparency.desc': 'Comunicação clara e práticas honestas em tudo o que fazemos.',
  'about.values.excellence.title': 'Excelência',
  'about.values.excellence.desc': 'Entregando serviço e resultados excepcionais para nossos clientes.',

  'about.team.title': 'Conheça nossa equipe de liderança',
  'about.team.subtitle': 'Profissionais experientes impulsionando a inovação em fintech',

  // FAQ Page
  'faq.title': 'Perguntas frequentes',
  'faq.subtitle': 'Encontre respostas para perguntas comuns sobre nossos serviços',

  'faq.general': 'Geral',
  'faq.account': 'Conta',
  'faq.security': 'Segurança',
  'faq.payments': 'Pagamentos',

  // Contact Page
  'contact.title': 'Entre em contato',
  'contact.subtitle': 'Estamos aqui para ajudar com quaisquer perguntas ou preocupações',

  'contact.info.title': 'Informações de contato',
  'contact.info.address': 'Visite-nos',
  'contact.info.email': 'Envie-nos um e-mail',
  'contact.info.phone': 'Ligue para nós',
  'contact.info.hours': 'Horário comercial',
  'contact.info.hoursValue': 'Segunda - Sexta: 8:00 - 19:00 PST',

  'contact.form.title': 'Envie-nos uma mensagem',
  'contact.form.name': 'Nome completo',
  'contact.form.email': 'Endereço de e-mail',
  'contact.form.subject': 'Assunto',
  'contact.form.message': 'Mensagem',
  'contact.form.send': 'Enviar mensagem',

  'contact.map.title': 'Nossa localização',
};

export default common;